<template>
  <div class="mail-box col-md-6">
    <table class="table table-hover table-mail">
      <thead class="table-head">
        <tr>
          <th>CÓDIGO</th>
          <th>TIPO</th>
          <th>PESSOA</th>
        </tr>
      </thead>

      <tbody class="table-list">
        <tr v-for="(listItem, listIdx) in creditors" :key="listIdx">
          <td>{{ listItem.code }}</td>
          <td>{{ formatType(listItem.creditorType) }}</td>
          <td>{{ formatPerson(listItem.personType) }}</td>
          <td class="list-command">
            <button class="btn btn-outline" @click="selectCreditor(listItem)">
              <i class="fa fa-edit text-success"></i>
            </button>
          </td>
          <td class="list-command">
            <button class="btn btn-outline" @click="removeCreditor(listItem)">
              <i class="fa fa-trash text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { toast } from '@/plugins/toast';
const CreditorType = {
  PROVIDER: 'provider',
  BROKER: 'broker',
};
const PersonType = {
  PHYSICAL: 'physical',
  LEGAL: 'legal',
};
export default {
  data() {
    return {
      creditors: [],
    };
  },
  mounted() {
    this.loadCreditors();
  },
  methods: {
    formatType(type) {
      if (type === CreditorType.PROVIDER) {
        return 'Fornecedor';
      } else {
        return 'Corretor';
      }
    },
    formatPerson(person) {
      if (person === PersonType.PHYSICAL) {
        return 'Física';
      } else {
        return 'Juridica';
      }
    },
    async loadCreditors() {
      try {
        const creditors = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAllCreditor',
        );
        this.creditors = creditors;
      } catch (error) {
        toast.error('Falha ao lista credores');
      }
    },
    selectCreditor(creditor) {
      this.$emit('edit-mode', creditor);
    },
    async removeCreditor({ _id }) {
      try {
        await this.$store.dispatch('FINANCIAL-ACCOUNT/Disable', _id);
        this.loadCreditors();
      } catch (error) {
        toast.error('Falha ao desabilitar credor');
      }
    },
  },
};
</script>